import React from 'react'
import s from './button.module.scss'
import { IconLoader2 } from '@tabler/icons-react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'

const themes = {
	primary: {
		className: s.primary,
		color: '#fff'
	},
	secondary: {
		className: s.secondary,
		color: '#A7AEB8'
	},
	telegram: {
		className: s.telegram,
		color: '#fff'
	},
	simple: {
		className: s.simple,
		color: '#A7AEB8'
	},
}

export const Button = ({theme = 'primary', fetching, to, target, rightIcon, lefticon, children, label, className, onClick, disabled, size = 'normal', ...props}) => {
	return (
		<>
		{!to || disabled ?
			<button {...props} onClick={disabled ? () => {} : onClick} className={classNames(className, s.button, themes[theme].className, fetching ? s.fetching : '', size === 'small' ? s.small  : '', disabled ? s.disabled : '')} disabled={disabled}>
				{fetching ? 
					<div className={s.iconWrapper}>
						<IconLoader2 color={themes[theme].color} className={s.loader} size={size === 'small' ? 14 : 16}/>
					</div>
					: 
					<>
						{lefticon ? lefticon : ''}
						<span>{label || children}</span>
						{rightIcon ? rightIcon : ''}
					</>
				}
			</button> :
			<NavLink to={to} className={classNames(className, s.button, themes[theme].className, fetching ? s.fetching : '', size === 'small' ? s.small  : '')} target={target}>
				{fetching ? 
					<div className={s.iconWrapper}>
						<IconLoader2 color={themes[theme].color} className={s.loader}/>
					</div>
					: 
					<>
						{lefticon ? lefticon : ''}
						<span>{label}</span>
						{rightIcon ? rightIcon : ''}
					</>
				}
			</NavLink>
		}		
		</>
	)
}


